"use client"

import { Accordion } from "@chakra-ui/react/accordion"
import { HStack } from "@chakra-ui/react/stack"

import { Education } from "@/types/getAbout"

import AccordionEducationContent from "./AccordionEducationContent"
import AccordionEducationHeader from "./AccordionEducationHeader"
import AccordionEducationTimeline from "./AccordionEducationTimeline"
import { getEducationDuration } from "./utils"

interface AccordionEducationItemProps {
  education: Education
  index: number
  totalItems: number
}

const AccordionEducationItem = ({
  education,
  index,
  totalItems,
}: AccordionEducationItemProps) => {
  const duration = getEducationDuration(education)

  return (
    <HStack
      alignContent="stretch"
      alignItems="stretch"
      className="card-item"
      flexDirection={"row"}
      flexWrap="nowrap"
      justifyContent="flex-start"
    >
      <HStack
        alignSelf="auto"
        className="collumn3"
        display={{ lg: "flex", lgDown: "none" }}
        minWidth={0}
        width={"100%"}
      />
      <AccordionEducationTimeline
        index={index}
        isLastItem={index === totalItems - 1}
      />
      <HStack alignSelf="auto" className="collumn1" minWidth={0} width={"100%"}>
        <Accordion.Item
          _hover={{ borderColor: "primary.400" }}
          bg={"bg.paper"}
          borderColor="border"
          borderWidth="1px"
          flexGrow={1}
          position="relative"
          rounded="xl"
          transition="border .3s ease-out, transform 0.2s ease-out"
          value={education.course_name}
        >
          <Accordion.ItemTrigger _hover={{ cursor: "pointer" }} px={4} py={4}>
            <AccordionEducationHeader
              duration={duration}
              education={education}
            />
          </Accordion.ItemTrigger>

          <Accordion.ItemContent>
            <AccordionEducationContent education={education} />
          </Accordion.ItemContent>
        </Accordion.Item>
      </HStack>
    </HStack>
  )
}

export default AccordionEducationItem
